module.exports = __webpack_public_path__ + "static/media/user.2b07a630.svg";